// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map__3wv1Y"};